//#region src/apiUrls.ts
var e = "https://rule.api.myparcel.nl", t = "https://rule.api.acceptance.myparcel.nl";
//#endregion
export { e as n, t };
